import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios';
import { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors } from '../interceptors/auth.interceptor';
import {
   cancelTokenRequestInterceptor,
   cancelTokenResponseErrorInterceptors,
   cancelTokenResponseSuccessInterceptors,
} from '../interceptors/cancel-token.interceptor';
import { errorResponseErrorInterceptor, errorResponseSuccessInterceptor } from '../interceptors/error.interceptor';
import { localizationRequestInterceptor } from '../interceptors/localization.interceptor';

//#region Cancel Token
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
   cancelable?: boolean;
}

const cancelTokenDict: { [request: string]: CancelTokenSource } = {};

function addCancelToken(request?: string, cancelToken?: CancelTokenSource) {
   if (!request || !cancelToken) return;
   cancelTokenDict[request] = cancelToken;
}
function removeCancelToken(request?: string) {
   if (!request) return;
   if (cancelTokenDict[request]) delete cancelTokenDict[request];
}
//#endregion

//#region Configs
const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL,
};

const largeFileConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL_FOR_LARGE_FILES,
};

const cacheFirstConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};
//#endregion

//#region Axios instance
const http = axios.create(baseConfig);
//#endregion

//#region Interceptors
// Remove authInterceptorId interceptor later in public app
const authInterceptorId = http.interceptors.request.use(authRequestInterceptor);
http.interceptors.request.use(localizationRequestInterceptor);
http.interceptors.request.use(cancelTokenRequestInterceptor);

http.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
http.interceptors.response.use(errorResponseSuccessInterceptor, errorResponseErrorInterceptor);
http.interceptors.response.use(cancelTokenResponseSuccessInterceptors, cancelTokenResponseErrorInterceptors);
//#endregion

export { addCancelToken, cacheFirstConfig, cancelTokenDict, http, largeFileConfig, removeCancelToken, authInterceptorId };
